"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearObject = void 0;
function clearObject(obj) {
    return typeof obj !== 'object'
        ? obj
        : Object.fromEntries(Object.entries(obj)
            .filter(([_, v]) => v != null && v !== '')
            // eslint-disable-next-line no-nested-ternary
            .map(([k, v]) => [k, typeof v !== 'object' ? v : !Array.isArray(v) ? clearObject(v) : v.map(clearObject)]));
}
exports.clearObject = clearObject;
//# sourceMappingURL=index.js.map